import React from "react";
import { makeObservable, observable } from "mobx";
import { observer } from "mobx-react";

@observer
export default class ThemeSelector extends React.Component<unknown> {
  @observable _theme = localStorage.getItem('theme') || (window.matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark');

  constructor(props: unknown) {
    super(props);
    makeObservable(this);
  }

  render() {
    return (
      <button onClick={this._onToggleClick} className="theme-toggle">
        {this._theme === 'light' ? '🌙' : '☀️'}
      </button>
    );
  }

  _onToggleClick = () => {
    const newTheme = this._theme === 'light' ? 'dark' : 'light';
    this._theme = newTheme;
    document.documentElement.setAttribute('data-theme', newTheme);
    localStorage.setItem('theme', newTheme);
  };

}